import axios from "../plugins/axios";
export default {
  state: {
    user: {
      data: {},
      error: [],
      form: {},
    },
    loading: false,
  },
  mutations: {
    setForm(state, data) {
      state.user.form = data;
    },
    setData(state, data) {
      state.user.data = data;
    },
    setErrors(state, data) {
      state.user.error = data;
    },
    setLoading(state, set) {
      state.loading = set;
    },
  },
  actions: {
    async user({ commit }, data) {
      commit("setLoading", true);
      try {
        let response = await axios.get("/api/user?page=" + data, {
          headers: { Authorization: "Bearer " + localStorage.getItem("token") },
        });
        if (response.status == 200) {
          commit("setData", response.data.user);
          commit("setLoading", false);
        }
      } catch (errors) {
        commit("setLoading", false);
      }
    },
    async searchUser({ commit }, data) {
      commit("setLoading", true);
      try {
        let headers = {
          Authorization: "Bearer " + localStorage.getItem("token"),
        };
        let response = !data
          ? await axios.get("/api/user?page=1", { headers })
          : await axios.get("/api/user", { params: { search: data }, headers });
        if (response.status == 200) {
          commit("setData", response.data.user);
          commit("setLoading", false);
        }
      } catch (errors) {
        commit("setLoading", false);
      }
    },
    async editUser({ commit }, data) {
      commit("setLoading", true);
      try {
        let response = await axios.put("/api/user/" + data.id, data, {
          headers: { Authorization: "Bearer " + localStorage.getItem("token") },
        });
        if (response.status == 200) {
          commit("setLoading", false);
          alert("Data berhasil diubah");
        }
      } catch (errors) {
        commit("setErrors", errors.response.data.errors);
        commit("setLoading", false);
      }
    },

    async addTambah({ commit }, data) {
      commit("setLoading", true);
      try {
        let response = await axios.post("/api/register", data);
        if (response.status == 200) {
          alert("Berhasil Tambah User");
          commit("setForm", {});
          commit("setErrors", {});
          commit("setLoading", false);
        }
      } catch (errors) {
        alert("Gagal Tambah User");
        commit("setErrors", errors.response.data.errors);
        commit("setLoading", false);
      }
    },
    async deleteUser({ commit }, data) {
      commit("setLoading", true);
      try {
        let response = await axios.delete("/api/user/" + data.id, data, {
          headers: { Authorization: "Bearer " + localStorage.getItem("token") },
        });
        if (response.status == 200) {
          commit("setLoading", false);
          alert("Data berhasil dihapus");
        }
      } catch (errors) {
        commit("setErrors", errors.response.data.errors);
        commit("setLoading", false);
      }
    },
  },
};
